import {json} from "p3";
import common from "../common";

/**
 * @param {string} str
 * @param {boolean} [lineBreak=false]
 * @return {string}
 */
export function locale(str, lineBreak = false) {
    const language = common.config.language;
    const key = str.replace(/(\r\n|\n|\r)/gm, "");
    console.log(key);
    let s = json("locale")[key];
    console.log(s);

    if (s && s[language] && s[language] != "") {
        s = s[language];
    } else {
        console.log(">>>>LOCALE NOT FOUND:", key);
        s = key;
        //s = json("locale_" + language)[key];
    }
    if (["za", "mecom", "apac"].indexOf(language) !== -1 && typeof s === "undefined") {
        s = json("locale")[key]['en'];
    }
    return (typeof s !== "undefined") ? s + (lineBreak ? "\n" : "") : str;
}

/**
 * @param {PIXI.BitmapText|PIXI.Text} label
 * @param {number} maxWidth
 */
export function resizeLabelToFitText(label, maxWidth) {
    const ratio = 1 / Math.max(1, label.width / maxWidth);
    label.scale.set(ratio);
}

/**
 * @param {[number]} weights 
 * @returns 
 */
export function weightedRand(weights) {
    let i;
    let sum = 0;
    let r = Math.random();
    
    for (i in weights) 
    {
        sum += weights[i];

        if (r <= sum) 
            return i;
    }
}